import { isPostFeedType } from "./isFeedPostType";

/**
 * @param {import("../types/feed-post").FeedPostGeneric} post
 */
function getCustomerIdFromFeedPost(post) {
  if (
    isPostFeedType("BLOCK_CAPACITY", post) ||
    isPostFeedType("FILE_CAPACITY", post) ||
    isPostFeedType("OBJECT_CAPACITY", post)
  ) {
    return post.data.customer_name;
  }

  if (isPostFeedType("MICROCODES", post)) {
    return post.data.customer_name;
  }

  if (isPostFeedType("SUPPORT_EXPIRATION", post)) {
    return post.data.customer_name;
  }

  if (isPostFeedType("SUPPORT_CASES", post)) {
    return post.data.customer_name;
  }

  return undefined;
}

export { getCustomerIdFromFeedPost };
